"use strict";
exports.__esModule = true;
var log_process_1 = require("../logic/log-process");
angular.module('smartorg.r6.mgmts.pypeerLog').directive("pypeerLog", ['$timeout', "$location", function ($timeout, $location) {
        return {
            restrict: 'E',
            template: require('../../template/pypeer-log.html'),
            transclude: true,
            scope: {
                smartorgApi: '=?'
            },
            link: function (scope) {
                scope.logData = [];
                scope.$on('manage:FetchPypeerLog', function () {
                    scope.daysFromToday = 3;
                    scope.userActionsOnly = true;
                    scope.fetch();
                    scope.$apply();
                });
                scope.fetch = function () {
                    if (scope.daysFromToday > 14) {
                        scope.daysFromToday = 14;
                    }
                    scope.logData = [];
                    scope.smartorgApi.fetchPypeerLog(scope.daysFromToday).then(function (response) {
                        scope.logData = JSON.parse(atob(decodeURIComponent(response.EncodedLog).replace(/\s/g, '')));
                        scope.logDict = response.logDict;
                        $timeout();
                    })["catch"](function (ex) {
                        console.error(ex);
                    });
                };
                scope.exportAllLogs = function () {
                    var allLogData = [];
                    scope.smartorgApi.fetchAllPypeerLog().then(function (response) {
                        var logDetails = JSON.parse(atob(decodeURIComponent(response.EncodedLogDetails).replace(/\s/g, '')));
                        var prefix = $location.host() == "localhost" ? "https://localhost" : "";
                        scope.csvUrl = prefix + logDetails['csvUrl'];
                        window.open(scope.csvUrl, '_self');
                        $timeout();
                    })["catch"](function (ex) {
                        console.error(ex);
                    });
                };
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
                scope.exportCsv = function () {
                    var csv = log_process_1.generateCsv(scope.logData, scope.logDict);
                    Common.downloadCSV(csv, 'log_');
                };
            }
        };
    }]);
//# sourceMappingURL=pypeer-log-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/pypeer-log/app/js/plumbing/pypeer-log-directive.js